import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { getTagInfoforSupplier, getUserProfile, updateTagInfoforSupplier, getOrderInfo, UploadtagUpdateImages } from "../services/api";
import { useSearchParams, useNavigate } from "react-router-dom";
import { convertFromISO } from "../utils/dateValidation";
import { PlusSquare } from "lucide-react";
import Cookies from "js-cookie";
import {
    Box,
    Grid,
    Container,
    TextField,
    Typography,
    useMediaQuery,
    Alert,
    Button,
    CircularProgress,
    Radio,
    RadioGroup,
    FormControlLabel,
} from "@mui/material";
import { useTranslation } from 'react-i18next';
import { set } from "lodash";

const TagUpdatePage = () => {
    const [searchParams] = useSearchParams();
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [BackColor, setBackColor] = useState("");
    const [UpdateMessage, setUpdateMessage] = useState("");

    const [loading, setLoading] = useState(true);
    const [loadingButton, setloadingButton] = useState(false);
    const orderId = searchParams.get('qr') || '';
    const [qrImagePreview, setqrImagePreview] = useState(null);
    const { t } = useTranslation();
    const [petImagePreview, setPetImagePreview] = useState(null);
    const isMobile = useMediaQuery("(max-width:850px)");
    const navigate = useNavigate();
    const [petContact, setPetContact] = useState("");
    const [tagInfo, setTagInfo] = useState({
        contact: "",
        petName: "",
        shortUrl: "",
        masterEmail: "",
        qrUrl: "",
        petUrl: "",
        orderId: "",
        location: "",
        petHuman: "",
        createdAt: "",
        updatedAt: "",
        tagId: "",
        pendingStatus: "",
        option: "",
        petContact: "",
    });

    // Get token from cookies
    const getUserId = () => {
        const id = Cookies.get("id");
        return id;
    };

    const userId = getUserId();
    useEffect(() => {
        if (!orderId) {
            setError(true);
            setBackColor("#d32f2f");
            setUpdateMessage("No information found!");
            setTimeout(() => {
                setError(false);
            }, 2000);
        }
        if (!userId) {
            navigate(`/login`);
        }
        setLoading(true);
        getUserProfile(userId)
            .then((response) => {
                const userRole = response.data.user.role;
                switch (userRole) {
                    case "user":
                        setLoading(false);
                        navigate("/landing");
                        break;
                    default:
                        setLoading(false);
                        return
                }
            })
            .catch((error) => {
                console.error("Error fetching User Role:", error);
            });
    }, [userId]);

    // Image compression utility
    const compressImage = async (file) => {
        const fileSizeMB = file.size / (1024 * 1024);

        let quality;
        if (fileSizeMB <= 0.3) {
            quality = 1;
        } else if (fileSizeMB <= 1) {
            quality = 0.5;
        } else if (fileSizeMB <= 2) {
            quality = 0.2;
        } else {
            quality = 0.1;
        }

        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = (event) => {
                const img = new Image();
                img.src = event.target.result;
                img.onload = () => {
                    const canvas = document.createElement('canvas');
                    canvas.width = img.width;
                    canvas.height = img.height;

                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(img, 0, 0);

                    canvas.toBlob(
                        (blob) => {
                            if (blob) {
                                const compressedFile = new File([blob], file.name, {
                                    type: 'image/jpeg',
                                    lastModified: Date.now(),
                                });
                                console.log(`Compressed ${file.name}: ${fileSizeMB.toFixed(2)}MB → ${(blob.size / (1024 * 1024)).toFixed(2)}MB`);
                                resolve(compressedFile);
                            } else {
                                reject(new Error('Compression failed'));
                            }
                        },
                        'image/jpeg',
                        quality
                    );
                };
                img.onerror = () => reject(new Error('Failed to load image'));
            };
            reader.onerror = () => reject(new Error('Failed to read file'));
        });
    };

    // Image upload handlers with compression
    const handleQrImageChange = async (e) => {
        const file = e.target.files[0];
        if (file && file.type.startsWith("image/")) {
            try {
                // Reject files larger than 10MB
                if (file.size / (1024 * 1024) > 10) {
                    setError(true);
                    setBackColor("#d32f2f");
                    setUpdateMessage(t('ImageTooLarge'));
                    setTimeout(() => {
                        setError(false);
                    }, 2000);
                    return;
                }

                const compressedFile = await compressImage(file);

                // Create preview
                const reader = new FileReader();
                reader.onloadend = () => {
                    setqrImagePreview(reader.result);
                };
                reader.readAsDataURL(compressedFile);

                setTagInfo({
                    ...tagInfo,
                    qrImageFile: compressedFile,
                });
            } catch (error) {
                console.error("Error processing QR image:", error);
                setError(true);
                setBackColor("#d32f2f");
                setUpdateMessage(t('FailedPhotoUpload'));
                setTimeout(() => {
                    setError(false);
                }, 2000);
            }
        }
    };

    const handlePetImageChange = async (e) => {
        const file = e.target.files[0];
        if (file && file.type.startsWith("image/")) {
            try {
                // Reject files larger than 10MB
                if (file.size / (1024 * 1024) > 10) {
                    setError(true);
                    setBackColor("#d32f2f");
                    setUpdateMessage(t('ImageTooLarge'));
                    setTimeout(() => {
                        setError(false);
                    }, 2000);
                    return;
                }

                const compressedFile = await compressImage(file);

                // Create preview
                const reader = new FileReader();
                reader.onloadend = () => {
                    setPetImagePreview(reader.result);
                };
                reader.readAsDataURL(compressedFile);

                setTagInfo({
                    ...tagInfo,
                    petImageFile: compressedFile,
                });
            } catch (error) {
                console.error("Error processing pet image:", error);
                setError(true);
                setBackColor("#d32f2f");
                setUpdateMessage(t('FailedPhotoUpload'));
                setTimeout(() => {
                    setError(false);
                }, 2000);
            }
        }
    };

    // Fetch supplier data if editing
    useEffect(() => {
        setLoading(true);
        getTagInfoforSupplier(orderId)
            .then((response) => {
                const tagData = response.data.form;
                setTagInfo((prev) => ({
                    ...prev,
                    ...tagData,
                    createdAt: convertFromISO(tagData.createdAt),
                    updatedAt: convertFromISO(tagData.updatedAt),
                }));
                if (tagData.petUrl) {
                    setPetImagePreview(tagData.petUrl);
                }
                if (tagData.qrUrl) {
                    setqrImagePreview(tagData.qrUrl);
                }
                if (tagData.orderId) {
                    getOrderInfo(tagData.orderId)
                        .then((response) => {
                            const tagData = response.data.form;
                            setPetContact(tagData.petContact || "");
                            setLoading(false);
                        })
                        .catch((error) => {
                            console.error("Error fetching Order Info:", error);
                        });
                }
            })
            .catch((error) => {
                console.error("Error fetching Tag Info:", error);
            });

    }, [orderId]);

    // Convert image file to base64
    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            if (!file) {
                resolve(null);
                return;
            }
            const reader = new FileReader();
            reader.onloadend = () => {
                resolve(reader.result);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    };

    const SubmitUpdatedTagInfo = async () => {
        tagInfo.updatedAt = convertFromISO(new Date());
        setloadingButton(true);
        try {
            // Check if there are new images to upload
            if (tagInfo.qrImageFile || tagInfo.petImageFile) {
                // Convert images to base64
                const qrImageBase64 = tagInfo.qrImageFile ? await fileToBase64(tagInfo.qrImageFile) : null;
                const petImageBase64 = tagInfo.petImageFile ? await fileToBase64(tagInfo.petImageFile) : null;

                // Only upload if at least one image exists
                if (qrImageBase64 || petImageBase64) {
                    const imageUploadData = {
                        qrImage: qrImageBase64,
                        petImage: petImageBase64,
                        tagId: tagInfo.tagId,
                    };

                    console.log("Uploading images...");
                    const uploadResponse = await UploadtagUpdateImages(imageUploadData);
                    
                    if (uploadResponse.status === 201) {
                        // Extract URLs from response and update tagInfo
                        const { qrUrl, petUrl } = uploadResponse.data;
                        console.log("Images uploaded successfully:", { qrUrl, petUrl });
                        
                        // Update tagInfo with new URLs
                        if (qrUrl) tagInfo.qrUrl = qrUrl;
                        if (petUrl) tagInfo.petUrl = petUrl;
                    } else {
                        throw new Error("Failed to upload images");
                    }
                }
            }

            // Now update the tag info with the URLs
            const response = await updateTagInfoforSupplier(orderId, tagInfo);
            if (response.status === 200) {
                setSuccess(true);
                setBackColor("#4CAF50");
                setUpdateMessage(t('SuccessTagInfo'));
                setTimeout(() => {
                    setSuccess(false);
                }, 2000);
            }
        } catch (error) {
            console.error("Error updating Tag Info:", error);
            setError(true);
            setBackColor("#d32f2f");
            setUpdateMessage(t('FailedTagInfo'));
            setTimeout(() => {
                setError(false);
            }, 2000);
        } finally {
            setloadingButton(false);
        }
    }

    if (loading) {
        return (
            <Box
                sx={{
                    bgcolor: "#fcf8f3",
                    minHeight: "100vh",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <Typography variant="h6" color="text.secondary">
                        {/* 載入中... */}
                        <img src="https://petpetclub.s3.ap-southeast-1.amazonaws.com/user-uploads/pets/68cb893a0feda12f2dbcc02b/68d4c8ce22baedfbe8b852dd.gif" alt=""
                            style={{
                                width: '150px',
                                height: 'auto',
                                mixBlendMode: 'multiply',
                            }} />
                        <div
                            style={{
                                fontWeight: "500px",
                                fontSize: "15px",
                                textAlign: "center",
                                fontFamily: "Lucida Console",

                            }}>
                            {t('Loading')}
                        </div>
                    </Typography>
                </Box>
            </Box>
        );
    }

    return (
        <Box sx={{ bgcolor: "#fcf8f3", minHeight: "100vh" }}>
            {/* Header */}
            <Navbar />

            {/* Main Content */}
            <Container
                maxWidth="lg"
                sx={{
                    py: { xs: 4, md: 8 },
                    px: 3,
                    mt: "70px", // Add top margin to account for fixed navbar height
                }}
            >
                <Typography
                    variant="h4"
                    sx={{
                        mb: { xs: 3, md: 5 },
                        fontWeight: "bold",
                        fontSize: { xs: "24px", sm: "28px", md: "32px" },
                    }}
                >
                    Tag Update Page
                </Typography>

                <Grid container justifyContent="space-between" sx={{ gap: '20px' }} >
                    <Grid item sx={{ display: 'flex', flexDirection: 'column', gap: '20px', width: isMobile ? "100%" : "40%" }}>
                        {/* Pet Name */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Pet Name:
                            </Typography>
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder=""
                                value={tagInfo.petName}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                                onChange={(e) =>
                                    setTagInfo({ ...tagInfo, petName: e.target.value })
                                }
                            />
                        </Box>

                        {/* petContact */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Pet Contact:
                            </Typography>
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder=""
                                value={petContact}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                                onChange={(e) => {
                                    setPetContact(e.target.value);
                                    setTagInfo({ ...tagInfo, petContact: e.target.value });
                                }}
                            />
                        </Box>
                        {/* Pet Short Url */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Pet Short Url:
                            </Typography>
                            <TextField
                                fullWidth
                                variant="outlined"
                                value={tagInfo.shortUrl}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                                onChange={(e) =>
                                    setTagInfo({ ...tagInfo, shortUrl: e.target.value })
                                }
                            />
                        </Box>

                        {/* Owner Name */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Owner Name:
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder=""
                                variant="outlined"
                                value={tagInfo.petHuman}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                                onChange={(e) =>
                                    setTagInfo({ ...tagInfo, petHuman: e.target.value })
                                }
                            />
                        </Box>

                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Phone Number:
                            </Typography>
                            <TextField
                                fullWidth
                                variant="outlined"
                                placeholder=""
                                value={tagInfo.contact}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                                onChange={(e) =>
                                    setTagInfo({ ...tagInfo, contact: e.target.value })
                                }
                            />
                        </Box>

                        {/* Address Delivery */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Address Delivery:
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder=""
                                variant="outlined"
                                value={tagInfo.location}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                                onChange={(e) =>
                                    setTagInfo({ ...tagInfo, location: e.target.value })
                                }
                            />
                        </Box>

                        {/* Order Number */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Order Number:
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder=""
                                variant="outlined"
                                value={tagInfo.orderId}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                                disabled
                                sx={{
                                    backgroundColor: "white",
                                    "&.Mui-disabled": {
                                        backgroundColor: "#e0e0e0",
                                    },
                                    "& .MuiOutlinedInput-root.Mui-disabled": {
                                        backgroundColor: "#e0e0e0",
                                    },
                                }}
                            />
                        </Box>

                        {/* Owner Email: */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Owner Email:
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder=""
                                variant="outlined"
                                value={tagInfo.masterEmail}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                                onChange={(e) =>
                                    setTagInfo({ ...tagInfo, masterEmail: e.target.value })
                                }
                            />
                        </Box>

                        {/* Tag Id */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Tag Id:
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder=""
                                variant="outlined"
                                value={tagInfo.tagId}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                                disabled
                                sx={{
                                    backgroundColor: "white",
                                    "&.Mui-disabled": {
                                        backgroundColor: "#e0e0e0",
                                    },
                                    "& .MuiOutlinedInput-root.Mui-disabled": {
                                        backgroundColor: "#e0e0e0",
                                    },
                                }}
                            />
                        </Box>

                        {/* Payment Status */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Payment Status:
                            </Typography>
                            <RadioGroup
                                row
                                value={tagInfo.pendingStatus}
                                onChange={(e) => setTagInfo({ ...tagInfo, pendingStatus: e.target.value })}
                            >
                                <FormControlLabel
                                    value={true}
                                    control={<Radio
                                        sx={{
                                            '&.Mui-checked': {
                                                color: '#FFB60C', // Checked color
                                            },
                                        }} />}
                                    label={t('Paid')}
                                />
                                <FormControlLabel
                                    value={false}
                                    control={<Radio
                                        sx={{
                                            '&.Mui-checked': {
                                                color: '#FFB60C', // Checked color
                                            },
                                        }} />}
                                    label={t('Pending')}
                                />
                            </RadioGroup>
                        </Box>

                        {/* Tag creation date */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Tag Creation Date:
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder=""
                                variant="outlined"
                                value={tagInfo.createdAt}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                                disabled
                                sx={{
                                    backgroundColor: "white",
                                    "&.Mui-disabled": {
                                        backgroundColor: "#e0e0e0",
                                    },
                                    "& .MuiOutlinedInput-root.Mui-disabled": {
                                        backgroundColor: "#e0e0e0",
                                    },
                                }}
                            />
                        </Box>
                        {/* Tag creation date */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Tag Updated Date:
                            </Typography>
                            <TextField
                                fullWidth
                                placeholder=""
                                variant="outlined"
                                value={tagInfo.updatedAt}
                                InputProps={{
                                    sx: {
                                        bgcolor: "white",
                                        borderRadius: "3px",
                                        height: { xs: "45px", md: "56px" },
                                        fontSize: { xs: "14px", md: "16px" },
                                    },
                                }}
                                disabled
                                sx={{
                                    backgroundColor: "white",
                                    "&.Mui-disabled": {
                                        backgroundColor: "#e0e0e0",
                                    },
                                    "& .MuiOutlinedInput-root.Mui-disabled": {
                                        backgroundColor: "#e0e0e0",
                                    },
                                }}
                            />
                        </Box>
                    </Grid>
                    <Grid item sx={{ display: 'flex', flexDirection: 'column', gap: '20px', width: isMobile ? "100%" : "40%" }}>
                        {/* Pet Tag Image */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Pet Tag Image:
                            </Typography>
                            <Box
                                sx={{
                                    border: 1,
                                    borderColor: "grey.300",
                                    borderRadius: 1,
                                    p: 4,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    minHeight: 350,
                                    backgroundColor: "white",
                                    position: "relative",
                                }}
                            >
                                {qrImagePreview ? (
                                    <img
                                        src={qrImagePreview}
                                        alt="預覽圖片"
                                        style={{
                                            maxWidth: "100%",
                                            maxHeight: 250,
                                            marginBottom: 16,
                                            borderRadius: 8,
                                        }}
                                    />
                                ) : (
                                    <PlusSquare size={48} />
                                )}
                                <input
                                    type="file"
                                    accept="image/*"
                                    style={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        opacity: 0,
                                        left: 0,
                                        top: 0,
                                        cursor: "pointer",
                                    }}
                                    onChange={handleQrImageChange}
                                />
                            </Box>
                        </Box>

                        {/* Pet Image */}
                        <Box>
                            <Typography
                                variant="h6"
                                sx={{
                                    mb: { xs: 0.5, md: 1 },
                                    fontSize: { xs: "16px", md: "18px" },
                                    fontWeight: "600",
                                }}
                            >
                                Pet Image:
                            </Typography>
                            <Box
                                sx={{
                                    border: 1,
                                    borderColor: "grey.300",
                                    borderRadius: 1,
                                    p: 4,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    minHeight: 350,
                                    backgroundColor: "white",
                                    position: "relative",
                                }}
                            >
                                {petImagePreview ? (
                                    <img
                                        src={petImagePreview}
                                        alt="預覽圖片"
                                        style={{
                                            maxWidth: "100%",
                                            maxHeight: 250,
                                            marginBottom: 16,
                                            borderRadius: 8,
                                        }}
                                    />
                                ) : (
                                    <PlusSquare size={48} />
                                )}
                                <input
                                    type="file"
                                    accept="image/*"
                                    style={{
                                        position: "absolute",
                                        width: "100%",
                                        height: "100%",
                                        opacity: 0,
                                        left: 0,
                                        top: 0,
                                        cursor: "pointer",
                                    }}
                                    onChange={handlePetImageChange}
                                />
                            </Box>
                        </Box>
                    </Grid>

                </Grid>
                <Box sx={{
                    display: 'flex',
                    flexDirection: isMobile ? 'column' : 'row',
                    gap: isMobile ? '20px' : '10%',
                    alignItems: 'center',
                    width: isMobile ? "100%" : "40%",
                    mt: 3,
                }}>
                    <Button
                        variant="contained"
                        onClick={SubmitUpdatedTagInfo}
                        sx={{
                            width: isMobile ? "100%" : "45%",
                            padding: "12px",
                            backgroundColor: isMobile ? "#FFC107" : "var(--color-button-primary)",
                            color: "var(--color-black)",
                            border: "none",
                            borderRadius: "3px",
                            fontSize: isMobile ? "var( --font-size-xs)" : "var(--font-size-base)",
                            fontWeight: "bold",
                            cursor: "pointer",
                            marginTop: "10px",
                            boxShadow: "none",
                            "&:hover": { background: "#FFB60C" },
                            "&:disabled": { background: "rgba(255, 182, 12, 0.5)" },
                            cursor: loadingButton ? "not-allowed" : "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                        }}
                        disabled={loadingButton}
                    >
                        {t('Save')}
                        {loadingButton && (
                            <span
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "flex-end",
                                }}
                            >
                                <CircularProgress size={20} color="inherit" />
                            </span>
                        )}
                    </Button>
                    <Button
                        type="button"
                        variant="outlined"
                        color="text.secondary"
                        onClick={() => navigate("/check_tag")}
                        sx={{
                            width: isMobile ? "100%" : "45%",
                            padding: "12px",
                            color: "var(--color-black)",
                            border: "1px solid black",
                            borderRadius: "3px",
                            fontSize: isMobile ? "var( --font-size-xs)" : "var(--font-size-base)",
                            fontWeight: "bold",
                            cursor: "pointer",
                            marginTop: isMobile ? "0px" : "10px",
                            boxShadow: "none",
                            "&:hover": {
                                backgroundColor: "black",
                                color: "white",
                            },
                        }}
                    >
                        {t('cancel')}
                    </Button>
                </Box>
            </Container>

            <Footer />
            <Box
                sx={{
                    position: "fixed",
                    bottom: 20,
                    right: (success || error) ? 20 : -500,
                    backgroundColor: BackColor,
                    color: "#fff",
                    padding: isMobile ? "12px 18px" : "16px 24px",
                    borderRadius: 2,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                    zIndex: 9999,
                    minWidth: 250,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    transition: (success || error)
                        ? "right 0.4s ease-out"
                        : "right 0.4s ease-in",
                }}
            >
                <Box
                    sx={{
                        width: 24,
                        height: 24,
                        borderRadius: "50%",
                        backgroundColor: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                    }}
                >
                    {error ? (
                        <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M18 6L6 18M6 6L18 18"
                                stroke={BackColor}
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    ) : (
                        <svg
                            width="14"
                            height="14"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M20 6L9 17L4 12"
                                stroke={BackColor}
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    )}
                </Box>
                <Typography fontWeight={600} fontSize={isMobile ? 12 : 16}>
                    {UpdateMessage}
                </Typography>
            </Box>
        </Box>
    );
};

export default TagUpdatePage;
